import { color } from "@/styles/theme";
import { css, Interpolation, Theme } from "@emotion/react";
import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export const Panel = (props: Props) => {
  return (
    <div css={container} {...props}>
      {props.children}
    </div>
  );
};

const container = css({
  backgroundColor: color.gray50,
  padding: "16px",
  display: "flex",
  flexDirection: "column",
  gap: 8,
});
